unit View.Nfse.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UConstantes, UUtils, XData.Web.Client, UHelperServer,
  UPersonalizacao_Tabela, UPersonalizacao_Tabela.Interfaces, System.StrUtils,
  UFrameDataBase, Vcl.Forms, System.DateUtils;

type
  TFViewNfseList = class(TForm)
    NfseDataset: TXDataWebDataSet;
    NfseDatasetnumero: TIntegerField;
    NfseDatasetnfse_transmitida: TBooleanField;
    NfseDatasetnfse_consolidada: TBooleanField;
    NfseDatasetnfse_cancelada: TBooleanField;
    NfseDatasetchave_acesso: TStringField;
    NfseDatasetdata_emissao: TDateTimeField;
    NfseDatasetnfse_xml_s3: TStringField;
    NfseDatasetanexo_sincronizado: TIntegerField;
    NfseDatasetcodigo_interno: TIntegerField;
    NfseDatasetexcluido: TBooleanField;
    NfseDatasetinclusao: TDateTimeField;
    NfseDatasetalteracao: TDateTimeField;
    NfseDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    XDataWebClient: TXDataWebClient;
    NfseDatasetid: TIntegerField;
    btnExportarExcel: TButton;
    btnPesquisarNfse: TButton;
    cbxNfseCancelada: TCheckBox;
    cbxNfseExcluidos: TCheckBox;
    edtEmissaoFinal: TDateTimePicker;
    edtEmissaoInicial: TDateTimePicker;
    frmBanco: TfrmDataBase;
    procedure WebFormCreate(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure XDataWebClientError(Error: TXDataClientError);
    procedure XDataWebClientLoad(Response: TXDataClientResponse);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure btnExportarExcelClick(Sender: TObject);
    procedure btnPesquisarNfseClick(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;

    procedure ConfigurarData;
    function GetFiltro : string;
    function ValidarDatas : string;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewNfseList: TFViewNfseList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewNfseList }

procedure TFViewNfseList.btnExportarExcelClick(Sender: TObject);
begin
  TUtils.ExportarDadosExcel(NfseDataset, WebDBTableControl1,
    FGridPlugin.FDatasetPlugin.FDataset.QueryString, FGridPlugin.FQuantidadeRegistrosBusca);
end;

procedure TFViewNfseList.btnPesquisarNfseClick(Sender: TObject);
begin
  ValidarDatas;
  FGridPlugin.FDatasetPlugin.FFilterPadrao := GetFiltro;
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewNfseList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

procedure TFViewNfseList.ConfigurarData;
begin
  edtEmissaoFinal.Max := Date;
  edtEmissaoInicial.Min := IncDay(Date, -365);
  edtEmissaoInicial.Date := IncDay(Date, -365);
  edtEmissaoFinal.Date := Date;
end;

class function TFViewNfseList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewNfseList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewNfseList, AElementID, Result, @AfterCreate);
end;

procedure TFViewNfseList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
    FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewNfseList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

function TFViewNfseList.GetFiltro: string;
var
  lListaFiltro : TStringList;
  lFiltroBanco : string;
begin
  Result := EmptyStr;
  lListaFiltro := TStringList.Create;

  try
    if not cbxNfseExcluidos.Checked then
      lListaFiltro.Add('(excluido eq false)');

    if not cbxNfseCancelada.Checked then
      lListaFiltro.Add('(nfse_cancelada eq false)');

    if ((edtEmissaoInicial.Text <> '') and (edtEmissaoFinal.Text <> '')) then
    begin
      lListaFiltro.Add('((data_emissao ge '+QuotedStr(edtEmissaoInicial.Text)+') and ' +
        '(data_emissao le '+QuotedStr(edtEmissaoFinal.Text)+'))');
    end;

    lFiltroBanco := frmBanco.GetFilterDataBase;

    if not lFiltroBanco.IsEmpty then
      lListaFiltro.Add('(data_base_id eq '+lFiltroBanco+')');

    if lListaFiltro.Count > 0 then
      Result := string.Join(' and ', lListaFiltro.ToStringArray);
  finally
    if Assigned(lListaFiltro) then
      FreeAndNil(lListaFiltro)
  end;
end;

procedure TFViewNfseList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

function TFViewNfseList.ValidarDatas: string;
begin
  Result := EmptyStr;

  if (Trim(edtEmissaoInicial.Text).IsEmpty) or (Trim(edtEmissaoFinal.Text).IsEmpty) then
  begin
    Result := 'Data inicial e final são obrigatórias!';
    Exit;
  end;

  if edtEmissaoInicial.Date > edtEmissaoFinal.Date then
  begin
    Result := 'A data inicial deve ser menor que a final!';
    Exit;
  end;

  if DaysBetween(edtEmissaoInicial.Date, edtEmissaoFinal.Date) > 365 then
  begin
    Result := 'O intervalo entre as datas deve ser menor ou igual a 1 ano!';
    Exit;
  end;
end;

procedure TFViewNfseList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;
  RecordNfseId : Integer;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

  procedure BaixarArquivoButtonClick(Sender: TObject);
  var
    lBotaoSelecionado : TButton;
    lJson : TJSObject;
    lBotaoNome : string;
  begin
    TUtils.ChamarDivLoading;

    lBotaoSelecionado := TButton(Sender);
    lBotaoNome := lBotaoSelecionado.Name;

    lJson := TJSObject.New;

    if lBotaoNome = 'rbtBaixarXml'  then
      lJson['tipo'] := 'xml'
    else if lBotaoNome = 'rbtBaixarDanfe' then
      lJson['tipo'] := 'danfe';

    lJson['codigo'] := lBotaoSelecionado.Tag;
    lJson['tabela'] := 'nfse';

    XDataWebClient.RawInvoke('IService.BaixarArquivo', [lJson]);
  end;

var
  Button: TButton;
  lHabilitarDanfeXml : Boolean;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ações' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      NfseDataset.Connection.Model.DefaultSchema.FindEntityType(NfseDataset.EntitySetName),
      NfseDataset.CurrentData
    );

    RecordNfseId := NfseDataset.FieldByName('id').AsInteger;

    lHabilitarDanfeXml := not NfseDataset.FieldByName('nfse_xml_s3').AsString.IsEmpty and
      (NfseDataset.FieldByName('anexo_sincronizado').AsString = '1');

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-eye"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_nfse');

    Button := TButton.Create(nil);
    Button.Name := 'rbtBaixarXml';
    Button.Tag := RecordNfseId;
    Button.Caption := '<i class="fas fa-file-code"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_baixar_xml');

    if lHabilitarDanfeXml then
    begin
      Button.OnClick := @BaixarArquivoButtonClick;
      Button.ElementClassName := 'btn btn-link btn-secondary btn-lg';
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Baixar XML');
    end
    else
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end;

    Button := TButton.Create(nil);
    Button.Name := 'rbtBaixarDanfe';
    Button.Tag := RecordNfseId;
    Button.Caption := '<i class="fas fa-file-pdf"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_baixar_danfse');

    if lHabilitarDanfeXml then
    begin
      Button.OnClick := @BaixarArquivoButtonClick;
      Button.ElementClassName := 'btn btn-link btn-danger btn-lg';
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Baixar Danfse');
    end
    else
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end;
  end;
end;

procedure TFViewNfseList.WebDBTableControl1GetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['numero', 'chave_acesso']) of
      0, 1: AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewNfseList.WebDBTableControl1GetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['excluido', 'nfse_transmitida',
      'nfse_consolidada', 'nfse_cancelada']) of
      0, 1, 2, 3:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>';
      end;
    end;
  end;
end;

procedure TFViewNfseList.WebFormCreate(Sender: TObject);
begin
  ConfigurarData;
  frmBanco.ConfigurarDataBase;

  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('nfse', 'active');
  TUtils.SetValorDicionarioClasses('documentos_fiscais_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_documentos_fiscais', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, NfseDataset, lcPaginator,
    lbPaginationInfo);

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'codigo_interno desc';
  FGridPlugin.FDatasetPlugin.FFilterPadrao := GetFiltro;
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewNfseList.XDataWebClientError(Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Error.ErrorMessage);
end;

procedure TFViewNfseList.XDataWebClientLoad(Response: TXDataClientResponse);
var
  lJSONObject: TJSObject;
begin
  lJSONObject := Response.ResultAsObject;
  THelperServer.BaixarAnexo(string(lJSONObject['arquivo_base64']), string(lJSONObject['arquivo_nome']));
end;

procedure TFViewNfseList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.nfse.list.pagination.info');
  WebDBTableControl1 := TDBTableControl.Create('view.nfse.list.table');
  cbPageSize := TComboBox.Create('view.nfse.list.cbPageSize');
  edSearch := TEdit.Create('view.nfse.list.search');
  lcPaginator := TListControl.Create('view.nfse.list.pagination');
  btnExportarExcel := TButton.Create('btnExportarExcel');
  btnPesquisarNfse := TButton.Create('btnPesquisarNfse');
  cbxNfseCancelada := TCheckBox.Create('cbxNfseCancelada');
  cbxNfseExcluidos := TCheckBox.Create('cbxNfseExcluidos');
  edtEmissaoFinal := TDateTimePicker.Create('edtEmissaoFinal');
  edtEmissaoInicial := TDateTimePicker.Create('edtEmissaoInicial');
  frmBanco := TfrmDataBase.Create(Self);
  NfseDataset := TXDataWebDataSet.Create(Self);
  NfseDatasetcodigo_interno := TIntegerField.Create(Self);
  NfseDatasetchave_acesso := TStringField.Create(Self);
  NfseDatasetdata_emissao := TDateTimeField.Create(Self);
  NfseDatasetnumero := TIntegerField.Create(Self);
  NfseDatasetnfse_transmitida := TBooleanField.Create(Self);
  NfseDatasetnfse_consolidada := TBooleanField.Create(Self);
  NfseDatasetnfse_cancelada := TBooleanField.Create(Self);
  NfseDatasetexcluido := TBooleanField.Create(Self);
  NfseDatasetinclusao := TDateTimeField.Create(Self);
  NfseDatasetalteracao := TDateTimeField.Create(Self);
  NfseDatasetexclusao := TDateTimeField.Create(Self);
  NfseDatasetnfse_xml_s3 := TStringField.Create(Self);
  NfseDatasetanexo_sincronizado := TIntegerField.Create(Self);
  NfseDatasetid := TIntegerField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);
  XDataWebClient := TXDataWebClient.Create(Self);

  frmBanco.LoadFromForm;
  lbPaginationInfo.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  btnExportarExcel.BeforeLoadDFMValues;
  btnPesquisarNfse.BeforeLoadDFMValues;
  cbxNfseCancelada.BeforeLoadDFMValues;
  cbxNfseExcluidos.BeforeLoadDFMValues;
  edtEmissaoFinal.BeforeLoadDFMValues;
  edtEmissaoInicial.BeforeLoadDFMValues;
  frmBanco.BeforeLoadDFMValues;
  frmBanco.cbbDataBasePesquisa.BeforeLoadDFMValues;
  NfseDataset.BeforeLoadDFMValues;
  NfseDatasetcodigo_interno.BeforeLoadDFMValues;
  NfseDatasetchave_acesso.BeforeLoadDFMValues;
  NfseDatasetdata_emissao.BeforeLoadDFMValues;
  NfseDatasetnumero.BeforeLoadDFMValues;
  NfseDatasetnfse_transmitida.BeforeLoadDFMValues;
  NfseDatasetnfse_consolidada.BeforeLoadDFMValues;
  NfseDatasetnfse_cancelada.BeforeLoadDFMValues;
  NfseDatasetexcluido.BeforeLoadDFMValues;
  NfseDatasetinclusao.BeforeLoadDFMValues;
  NfseDatasetalteracao.BeforeLoadDFMValues;
  NfseDatasetexclusao.BeforeLoadDFMValues;
  NfseDatasetnfse_xml_s3.BeforeLoadDFMValues;
  NfseDatasetanexo_sincronizado.BeforeLoadDFMValues;
  NfseDatasetid.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  XDataWebClient.BeforeLoadDFMValues;
  try
    Name := 'FViewNfseList';
    Width := 599;
    Height := 366;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 320;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 38;
    WebDBTableControl1.Width := 337;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#245'es';
      Width := 150;
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'C'#243'd. Retaguarda';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'chave_acesso';
      Title := 'Chave Acesso';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_emissao';
      Title := 'Emiss'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'numero';
      Title := 'N'#250'mero';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nfse_transmitida';
      Title := 'Transmitida';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nfse_consolidada';
      Title := 'Consolidada';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nfse_cancelada';
      Title := 'Cancelada';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 11;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 224;
    edSearch.Top := 11;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 309;
    lcPaginator.Width := 105;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    btnExportarExcel.SetParentComponent(Self);
    btnExportarExcel.Name := 'btnExportarExcel';
    btnExportarExcel.Left := 376;
    btnExportarExcel.Top := 30;
    btnExportarExcel.Width := 96;
    btnExportarExcel.Height := 25;
    btnExportarExcel.Caption := 'Exportar Excel';
    btnExportarExcel.ChildOrder := 11;
    btnExportarExcel.HeightPercent := 100.000000000000000000;
    btnExportarExcel.WidthPercent := 100.000000000000000000;
    SetEvent(btnExportarExcel, Self, 'OnClick', 'btnExportarExcelClick');
    btnPesquisarNfse.SetParentComponent(Self);
    btnPesquisarNfse.Name := 'btnPesquisarNfse';
    btnPesquisarNfse.Left := 376;
    btnPesquisarNfse.Top := 173;
    btnPesquisarNfse.Width := 96;
    btnPesquisarNfse.Height := 25;
    btnPesquisarNfse.Caption := 'Pesquisar';
    btnPesquisarNfse.ChildOrder := 11;
    btnPesquisarNfse.HeightPercent := 100.000000000000000000;
    btnPesquisarNfse.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarNfse, Self, 'OnClick', 'btnPesquisarNfseClick');
    cbxNfseCancelada.SetParentComponent(Self);
    cbxNfseCancelada.Name := 'cbxNfseCancelada';
    cbxNfseCancelada.Left := 376;
    cbxNfseCancelada.Top := 145;
    cbxNfseCancelada.Width := 120;
    cbxNfseCancelada.Height := 22;
    cbxNfseCancelada.Caption := 'Exibir Canceladas?';
    cbxNfseCancelada.ChildOrder := 9;
    cbxNfseCancelada.HeightPercent := 100.000000000000000000;
    cbxNfseCancelada.WidthPercent := 100.000000000000000000;
    cbxNfseExcluidos.SetParentComponent(Self);
    cbxNfseExcluidos.Name := 'cbxNfseExcluidos';
    cbxNfseExcluidos.Left := 376;
    cbxNfseExcluidos.Top := 117;
    cbxNfseExcluidos.Width := 120;
    cbxNfseExcluidos.Height := 22;
    cbxNfseExcluidos.Caption := 'Exibir Exclu'#237'dos?';
    cbxNfseExcluidos.ChildOrder := 9;
    cbxNfseExcluidos.HeightPercent := 100.000000000000000000;
    cbxNfseExcluidos.WidthPercent := 100.000000000000000000;
    edtEmissaoFinal.SetParentComponent(Self);
    edtEmissaoFinal.Name := 'edtEmissaoFinal';
    edtEmissaoFinal.Left := 376;
    edtEmissaoFinal.Top := 89;
    edtEmissaoFinal.Width := 120;
    edtEmissaoFinal.Height := 22;
    edtEmissaoFinal.BorderStyle := bsSingle;
    edtEmissaoFinal.ChildOrder := 109;
    edtEmissaoFinal.Color := clWhite;
    edtEmissaoFinal.Date := 45980.718362395830000000;
    edtEmissaoFinal.Role := '';
    edtEmissaoFinal.Text := '';
    edtEmissaoInicial.SetParentComponent(Self);
    edtEmissaoInicial.Name := 'edtEmissaoInicial';
    edtEmissaoInicial.Left := 376;
    edtEmissaoInicial.Top := 61;
    edtEmissaoInicial.Width := 120;
    edtEmissaoInicial.Height := 22;
    edtEmissaoInicial.BorderStyle := bsSingle;
    edtEmissaoInicial.ChildOrder := 109;
    edtEmissaoInicial.Color := clWhite;
    edtEmissaoInicial.Date := 45980.718362395830000000;
    edtEmissaoInicial.Role := '';
    edtEmissaoInicial.Text := '';
    frmBanco.SetParentComponent(Self);
    frmBanco.Name := 'frmBanco';
    frmBanco.Left := 376;
    frmBanco.Top := 204;
    frmBanco.Width := 215;
    frmBanco.Height := 61;
    frmBanco.TabOrder := 10;
    frmBanco.Visible := False;
    frmBanco.cbbDataBasePesquisa.Height := 21;
    NfseDataset.SetParentComponent(Self);
    NfseDataset.Name := 'NfseDataset';
    NfseDataset.EntitySetName := 'Nfse';
    NfseDataset.Connection := DMConnection.ApiConnection;
    NfseDataset.Left := 72;
    NfseDataset.Top := 88;
    NfseDatasetcodigo_interno.SetParentComponent(NfseDataset);
    NfseDatasetcodigo_interno.Name := 'NfseDatasetcodigo_interno';
    NfseDatasetcodigo_interno.FieldName := 'codigo_interno';
    NfseDatasetcodigo_interno.Required := True;
    NfseDatasetchave_acesso.SetParentComponent(NfseDataset);
    NfseDatasetchave_acesso.Name := 'NfseDatasetchave_acesso';
    NfseDatasetchave_acesso.FieldName := 'chave_acesso';
    NfseDatasetchave_acesso.Size := 255;
    NfseDatasetdata_emissao.SetParentComponent(NfseDataset);
    NfseDatasetdata_emissao.Name := 'NfseDatasetdata_emissao';
    NfseDatasetdata_emissao.FieldName := 'data_emissao';
    NfseDatasetdata_emissao.DisplayFormat := 'dd/mm/yy';
    NfseDatasetnumero.SetParentComponent(NfseDataset);
    NfseDatasetnumero.Name := 'NfseDatasetnumero';
    NfseDatasetnumero.FieldName := 'numero';
    NfseDatasetnfse_transmitida.SetParentComponent(NfseDataset);
    NfseDatasetnfse_transmitida.Name := 'NfseDatasetnfse_transmitida';
    NfseDatasetnfse_transmitida.FieldName := 'nfse_transmitida';
    NfseDatasetnfse_consolidada.SetParentComponent(NfseDataset);
    NfseDatasetnfse_consolidada.Name := 'NfseDatasetnfse_consolidada';
    NfseDatasetnfse_consolidada.FieldName := 'nfse_consolidada';
    NfseDatasetnfse_cancelada.SetParentComponent(NfseDataset);
    NfseDatasetnfse_cancelada.Name := 'NfseDatasetnfse_cancelada';
    NfseDatasetnfse_cancelada.FieldName := 'nfse_cancelada';
    NfseDatasetexcluido.SetParentComponent(NfseDataset);
    NfseDatasetexcluido.Name := 'NfseDatasetexcluido';
    NfseDatasetexcluido.FieldName := 'excluido';
    NfseDatasetinclusao.SetParentComponent(NfseDataset);
    NfseDatasetinclusao.Name := 'NfseDatasetinclusao';
    NfseDatasetinclusao.FieldName := 'inclusao';
    NfseDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    NfseDatasetalteracao.SetParentComponent(NfseDataset);
    NfseDatasetalteracao.Name := 'NfseDatasetalteracao';
    NfseDatasetalteracao.FieldName := 'alteracao';
    NfseDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    NfseDatasetexclusao.SetParentComponent(NfseDataset);
    NfseDatasetexclusao.Name := 'NfseDatasetexclusao';
    NfseDatasetexclusao.FieldName := 'exclusao';
    NfseDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    NfseDatasetnfse_xml_s3.SetParentComponent(NfseDataset);
    NfseDatasetnfse_xml_s3.Name := 'NfseDatasetnfse_xml_s3';
    NfseDatasetnfse_xml_s3.Tag := 1;
    NfseDatasetnfse_xml_s3.FieldName := 'nfse_xml_s3';
    NfseDatasetnfse_xml_s3.Size := 65536;
    NfseDatasetanexo_sincronizado.SetParentComponent(NfseDataset);
    NfseDatasetanexo_sincronizado.Name := 'NfseDatasetanexo_sincronizado';
    NfseDatasetanexo_sincronizado.Tag := 1;
    NfseDatasetanexo_sincronizado.FieldName := 'anexo_sincronizado';
    NfseDatasetid.SetParentComponent(NfseDataset);
    NfseDatasetid.Name := 'NfseDatasetid';
    NfseDatasetid.Tag := 1;
    NfseDatasetid.FieldName := 'id';
    NfseDatasetid.Required := True;
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := NfseDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 144;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 280;
    tmrConsulta.Top := 168;
    XDataWebClient.SetParentComponent(Self);
    XDataWebClient.Name := 'XDataWebClient';
    XDataWebClient.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebClient, Self, 'OnLoad', 'XDataWebClientLoad');
    SetEvent(XDataWebClient, Self, 'OnError', 'XDataWebClientError');
    XDataWebClient.Left := 376;
    XDataWebClient.Top := 304;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    btnExportarExcel.AfterLoadDFMValues;
    btnPesquisarNfse.AfterLoadDFMValues;
    cbxNfseCancelada.AfterLoadDFMValues;
    cbxNfseExcluidos.AfterLoadDFMValues;
    edtEmissaoFinal.AfterLoadDFMValues;
    edtEmissaoInicial.AfterLoadDFMValues;
    frmBanco.AfterLoadDFMValues;
    frmBanco.cbbDataBasePesquisa.AfterLoadDFMValues;
    NfseDataset.AfterLoadDFMValues;
    NfseDatasetcodigo_interno.AfterLoadDFMValues;
    NfseDatasetchave_acesso.AfterLoadDFMValues;
    NfseDatasetdata_emissao.AfterLoadDFMValues;
    NfseDatasetnumero.AfterLoadDFMValues;
    NfseDatasetnfse_transmitida.AfterLoadDFMValues;
    NfseDatasetnfse_consolidada.AfterLoadDFMValues;
    NfseDatasetnfse_cancelada.AfterLoadDFMValues;
    NfseDatasetexcluido.AfterLoadDFMValues;
    NfseDatasetinclusao.AfterLoadDFMValues;
    NfseDatasetalteracao.AfterLoadDFMValues;
    NfseDatasetexclusao.AfterLoadDFMValues;
    NfseDatasetnfse_xml_s3.AfterLoadDFMValues;
    NfseDatasetanexo_sincronizado.AfterLoadDFMValues;
    NfseDatasetid.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
    XDataWebClient.AfterLoadDFMValues;
  end;
end;

end.
